<template>
  <view class="content">
   
    <view class="card">
      <text class="title">任务信息</text>
      <view class="info-row">
        <text class="label">项目ID：</text><text class="value">{{ pid }}</text>
      </view>
      <view class="info-row">
        <text class="label">任务ID：</text><text class="value">{{ id }}</text>
      </view>
      <view class="info-row">
        <text class="label">处理状态：</text><text class="value">{{ status }}</text>
      </view>
    </view>
    <view class="card">
      <text class="title">{{ schema.title }}</text>
      <view class="form">
        <view class="form-item" v-for="(field, idx) in schema.fields" :key="idx">
          <text class="form-label">
            {{ field.label }}<text v-if="field.required" class="required">*</text>
          </text>
          <view class="form-control" v-if="field.type === 'input'">
            <input class="input" v-model="form[field.key]" :placeholder="field.placeholder || ''" />
          </view>
          <view class="form-control" v-else-if="field.type === 'textarea'">
            <textarea class="textarea" v-model="form[field.key]" :placeholder="field.placeholder || ''" />
          </view>
          <view class="form-control" v-else-if="field.type === 'select'">
            <picker mode="selector" :range="field.options || []" @change="onSelectChange(field, $event)">
              <view class="picker">{{ form[field.key] || '请选择' }}</view>
            </picker>
          </view>
          <view class="form-control" v-else-if="field.type === 'radio'">
            <radio-group @change="onRadioChange(field, $event)">
              <label class="radio-item" v-for="opt in field.options || []" :key="opt">
                <radio :value="opt" :checked="form[field.key] === opt" />
                <text class="radio-text">{{ opt }}</text>
              </label>
            </radio-group>
          </view>
          <view class="form-control" v-else-if="field.type === 'checkbox'">
            <checkbox-group @change="onCheckboxChange(field, $event)">
              <label class="checkbox-item" v-for="opt in field.options || []" :key="opt">
                <checkbox :value="opt" :checked="(form[field.key] || []).includes(opt)" />
                <text class="checkbox-text">{{ opt }}</text>
              </label>
            </checkbox-group>
          </view>
          <view class="form-control" v-else-if="field.type === 'date'">
            <picker mode="date" :value="form[field.key]" @change="onDateChange(field, $event)">
              <view class="picker">{{ form[field.key] || '请选择日期' }}</view>
            </picker>
          </view>
          <view class="form-control" v-else-if="field.type === 'switch'">
            <switch :checked="!!form[field.key]" @change="onSwitchChange(field, $event)" />
          </view>
          <view class="form-control" v-else-if="field.type === 'upload'">
            <view class="upload-actions">
              <button class="btn" @click="onChooseImage(field)">选择图片</button>
            </view>
            <view class="thumbs">
              <view class="thumb" v-for="(file, fidx) in (form[field.key] || [])" :key="fidx">
                <image class="thumb-img" :src="file.path" mode="aspectFill"></image>
                <view class="thumb-del" @click="removeAttachment(field, fidx)">删除</view>
              </view>
            </view>
          </view>
        </view>
      </view>
      <view class="actions">
        <button class="btn primary" @click="handleSubmit">提交</button>
      </view>
    </view>
    <BottomTabBar active="progress" />
  </view>
</template>

<script>
import BottomTabBar from '@/components/BottomTabBar.vue'
export default {
  name: 'TaskProcess',
  components: { BottomTabBar },
  data() {
    return {
      id: '',
      pid: '',
      status: '待处理',
      schema: { title: '', fields: [] },
      form: {}
    }
  },
  onLoad(query) {
    this.id = query.id || ''
    this.pid = query.pid || ''
    this.fetchSchema()
  },
  methods: {
    fetchSchema() {
      const s = {
        title: '任务处理表单',
        fields: [
          { type: 'input', label: '标题', key: 'title', required: true, placeholder: '请输入标题' },
          { type: 'textarea', label: '说明', key: 'desc', required: false, placeholder: '请输入说明' },
          { type: 'select', label: '类别', key: 'category', required: true, options: ['施工', '采购', '验收'] },
          { type: 'radio', label: '紧急程度', key: 'priority', required: true, options: ['低', '中', '高'] },
          { type: 'checkbox', label: '涉及阶段', key: 'phases', required: false, options: ['在库', '前期', '实施', '竣工'] },
          { type: 'date', label: '截止日期', key: 'due', required: true },
          { type: 'switch', label: '是否需要复核', key: 'review', required: false },
          { type: 'upload', label: '附件', key: 'attachments', required: false, max: 3 }
        ]
      }
      this.schema = s
      const obj = {}
      for (const f of s.fields) {
        if (f.type === 'checkbox' || f.type === 'upload') obj[f.key] = []
        else if (f.type === 'switch') obj[f.key] = false
        else obj[f.key] = ''
      }
      this.form = obj
    },
    onSelectChange(field, e) {
      const i = e.detail.value
      const opts = field.options || []
      this.form[field.key] = opts[i] || ''
    },
    onDateChange(field, e) {
      this.form[field.key] = e.detail.value
    },
    onRadioChange(field, e) {
      this.form[field.key] = e.detail.value
    },
    onCheckboxChange(field, e) {
      this.form[field.key] = e.detail.value || []
    },
    onSwitchChange(field, e) {
      this.form[field.key] = !!e.detail.value
    },
    onChooseImage(field) {
      const current = this.form[field.key] || []
      const max = field.max || 9
      const remain = Math.max(0, max - current.length)
      if (remain <= 0) {
        uni.showToast({ title: '已达最大数量', icon: 'none' })
        return
      }
      uni.chooseImage({
        count: remain,
        success: (res) => {
          const files = (res.tempFiles || []).map(f => ({ path: f.path }))
          this.form[field.key] = [...current, ...files]
        }
      })
    },
    removeAttachment(field, idx) {
      const arr = this.form[field.key] || []
      arr.splice(idx, 1)
      this.form[field.key] = [...arr]
    },
    validate() {
      for (const f of this.schema.fields) {
        if (!f.required) continue
        const v = this.form[f.key]
        if (f.type === 'checkbox' || f.type === 'upload') {
          if (!Array.isArray(v) || v.length === 0) {
            uni.showToast({ title: `请填写${f.label}`, icon: 'none' })
            return false
          }
        } else if (!v && v !== 0 && v !== false) {
          uni.showToast({ title: `请填写${f.label}`, icon: 'none' })
          return false
        }
      }
      return true
    },
    handleSubmit() {
      if (!this.validate()) return
      this.status = '已处理'
      uni.showToast({ title: '提交成功', icon: 'success' })
      setTimeout(() => {
        uni.navigateBack()
      }, 800)
    }
  }
}
</script>

<style scoped>
.content { width: 100%; min-height: 100vh; background-color: #f5f7fa; padding-bottom: 120rpx; }
.navbar { display: flex; align-items: center; justify-content: space-between; padding: 0 30rpx; height: 88rpx; background: linear-gradient(90deg, #1E88E5, #26A69A); color: #fff; }
.navbar-title { font-size: 36rpx; font-weight: 600; }
.card { background-color: #fff; margin: 20rpx; border-radius: 16rpx; padding: 24rpx; box-shadow: 0 2rpx 10rpx rgba(0,0,0,0.05); }
.title { font-size: 32rpx; font-weight: 600; color: #333; margin-bottom: 16rpx; }
.info-row { display: flex; margin: 10rpx 0; }
.label { width: 160rpx; font-size: 28rpx; color: #666; }
.value { flex: 1; font-size: 28rpx; color: #333; }
.form { margin-top: 10rpx; }
.form-item { margin-bottom: 20rpx; }
.form-label { font-size: 28rpx; color: #333; margin-bottom: 10rpx; display: block; }
.required { color: #FF5252; margin-left: 6rpx; }
.form-control { background: #fafafa; border-radius: 12rpx; padding: 16rpx; }
.input { height: 72rpx; font-size: 28rpx; }
.textarea { width: 100%; min-height: 140rpx; font-size: 28rpx; }
.picker { height: 72rpx; line-height: 72rpx; color: #666; }
.radio-item, .checkbox-item { display: inline-flex; align-items: center; margin-right: 24rpx; }
.radio-text, .checkbox-text { font-size: 26rpx; color: #333; margin-left: 8rpx; }
.upload-actions { margin-bottom: 12rpx; }
.thumbs { display: flex; flex-wrap: wrap; gap: 12rpx; }
.thumb { width: 160rpx; height: 160rpx; position: relative; }
.thumb-img { width: 100%; height: 100%; border-radius: 12rpx; }
.thumb-del { position: absolute; right: 8rpx; top: 8rpx; background: rgba(0,0,0,0.6); color: #fff; font-size: 22rpx; padding: 4rpx 8rpx; border-radius: 8rpx; }
.actions { margin-top: 20rpx; display: flex; }
.btn { flex: 1; height: 72rpx; line-height: 72rpx; border-radius: 12rpx; font-size: 28rpx; border: none; }
.primary { background-color: #26A69A; color: #fff; }
</style>
